import React from 'react';
import { motion } from 'framer-motion';

const CaseStudiesSection = () => {
  const caseStudies = [
    {
      icon: "🏪",
      title: "Retail Business Owner (Chennai)",
      result: "Doubled repeat orders in 60 days",
      description: "Automated customer follow-ups increased loyalty"
    },
    {
      icon: "📚", 
      title: "Coaching Institute (Coimbatore)",
      result: "3x admissions with automated nurturing",
      description: "Lead nurturing system converted more prospects"
    },
    {
      icon: "🏭",
      title: "Manufacturer (Madurai)", 
      result: "Saved 4 hrs/day, AI handled follow-ups",
      description: "Complete automation of customer communications"
    }
  ];

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            📊 Real Tamil Business Success Stories
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {caseStudies.map((study, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 sm:p-8 border border-white border-opacity-20 hover:bg-opacity-20 transition-all duration-300"
            >
              <div className="text-center">
                <div className="text-4xl sm:text-5xl mb-4">{study.icon}</div>
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-4">
                  {study.title}
                </h3>
                <p className="text-green-400 text-lg sm:text-xl font-semibold mb-3">
                  {study.result}
                </p>
                <p className="text-gray-300 text-base sm:text-lg">
                  {study.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="text-center bg-gradient-to-r from-green-500 to-blue-500 rounded-xl p-6 sm:p-8"
        >
          <p className="text-white text-xl sm:text-2xl font-bold">
            👉 WhatsApp API Automation already <span className="text-yellow-300">helped 50,000+ businesses worldwide</span> scale sales.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;